const messages = {
    en: {
        role: {
            permissions: {
                ZONE_MENU: "Access Zone menu",
                ZONE_SHOW: "View Zone",
                ZONE_UPDATE: "Modify Zone",
                ZONE_CREATE: "Create Zone",
                ZONE_DELETE: "Delete Zone",
                LOCATION_MENU: "Access Location menu",
                LOCATION_SHOW: "View Location",
                LOCATION_UPDATE: "Modify Location",
                LOCATION_CREATE: "Create Location",
                LOCATION_DELETE: "Delete Location",
                LOCALITY_MENU: "Access Locality menu",
                LOCALITY_SHOW: "View Locality",
                LOCALITY_UPDATE: "Modify Locality",
                LOCALITY_CREATE: "Create Locality",
                LOCALITY_DELETE: "Delete Locality"
            }
        }
    },
    es: {
        role: {
            permissions: {
                ZONE_MENU: "Acceder al menú de Zonas",
                ZONE_SHOW: "Ver Zona",
                ZONE_UPDATE: "Modificar Zona",
                ZONE_CREATE: "Crear Zona",
                ZONE_DELETE: "Eliminar Zona",
                LOCATION_MENU: "Acceder al menú de Ubicaciones",
                LOCATION_SHOW: "Ver Ubicación",
                LOCATION_UPDATE: "Modificar Ubicación",
                LOCATION_CREATE: "Crear Ubicación",
                LOCATION_DELETE: "Eliminar Ubicación",
                LOCALITY_MENU: "Acceder al menú de Localidades",
                LOCALITY_SHOW: "Ver Localidad",
                LOCALITY_UPDATE: "Modificar Localidad",
                LOCALITY_CREATE: "Crear Localidad",
                LOCALITY_DELETE: "Eliminar Localidad"
            }
        }
    },
    pt: {
        role: {
            permissions: {
                ZONE_MENU: "Acessar menu de Zonas",
                ZONE_SHOW: "Ver Zona",
                ZONE_UPDATE: "Modificar Zona",
                ZONE_CREATE: "Criar Zona",
                ZONE_DELETE: "Eliminar Zona",
                LOCATION_MENU: "Acessar menu de Localizações",
                LOCATION_SHOW: "Ver Localização",
                LOCATION_UPDATE: "Modificar Localização",
                LOCATION_CREATE: "Criar Localização",
                LOCATION_DELETE: "Eliminar Localização",
                LOCALITY_MENU: "Acessar menu de Localidades",
                LOCALITY_SHOW: "Ver Localidade",
                LOCALITY_UPDATE: "Modificar Localidade",
                LOCALITY_CREATE: "Criar Localidade",
                LOCALITY_DELETE: "Eliminar Localidade"
            }
        }
    }
}

export default messages
